export const toastDanger = {
    theme: {
        "--toastBackground": "#F56565",
        "--toastProgressBackground": "#C53030",
    },
};
